import { render } from "./ListeSocietePage.vue?vue&type=template&id=a98b1526&ts=true"
import script from "./ListeSocietePage.vue?vue&type=script&lang=ts"
export * from "./ListeSocietePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__